import { useSelector } from 'react-redux';

/**
 * basketNotFromRedux can be used to set a basket that has no relation to the redux state.
 * If no basketNotFromRedux is supplied the standard basket in the redux-state will be used.
 *
 * @param {basketNotFromRedux} - Could for example be a gift-certificate-basket.
 * @returns object - basket
 */

export default (basketNotFromRedux = false) => {
    if (basketNotFromRedux) {
        return basketNotFromRedux;
    }

    return useSelector(
        ({ basket }) => basket,
        (current, prev) => JSON.stringify(current) === JSON.stringify(prev)
    );
};
